import React, { useEffect, useRef, useState } from 'react';

// Counts the price up from zero each time `play` increments; otherwise shows the value directly
export const CountUpPrice = ({ value, format, play, duration = 1100 }) => {
  const [shown, setShown] = useState(value);
  const lastPlay = useRef(play);
  useEffect(() => {
    if (play === lastPlay.current || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      lastPlay.current = play;
      setShown(value);
      return undefined;
    }
    lastPlay.current = play;
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      setShown(value * (1 - Math.pow(1 - t, 3)));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value, play, duration]);
  return <span data-testid="price-count-up">{format(Math.round(shown * 100) / 100)}</span>;
};
